var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4999,
    cy: 20.3157,
    rx: 20.1519,
    ry: 20.1526,
    fill: "#9378C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1514 10.498H14.8167C11.9629 10.498 9.64941 12.8115 9.64941 15.6654V26C9.64941 28.8539 11.9629 31.1674 14.8167 31.1674H25.1514C28.0052 31.1674 30.3187 28.8539 30.3187 26V15.6654C30.3187 12.8115 28.0052 10.498 25.1514 10.498Z",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 20.1808C24.2455 21.0409 24.0985 21.9193 23.6981 22.6911C23.2976 23.4629 22.664 24.0888 21.8873 24.4797C21.1106 24.8706 20.2305 25.0067 19.372 24.8686C18.5136 24.7304 17.7205 24.3251 17.1057 23.7103C16.4909 23.0954 16.0855 22.3024 15.9474 21.4439C15.8093 20.5855 15.9453 19.7053 16.3363 18.9286C16.7272 18.152 17.353 17.5183 18.1248 17.1179C18.8966 16.7174 19.775 16.5705 20.6351 16.698C21.5125 16.8281 22.3247 17.237 22.9519 17.8641C23.579 18.4913 23.9878 19.3035 24.1179 20.1808Z",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.668 15.1484H25.6783",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2acdcebb24deb552f5b262d9234224e2.svg";
export { ForwardRef as ReactComponent };